module.exports = __webpack_public_path__ + "img/alert.a04ddd1a.svg";